import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '@env/environment';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataListOfClientJobs, ListOfClientJobs, Clients } from 'app/view/clients/modal/clients';
import { ClientService } from 'app/view/clients/services/client.service';
import { DepartmentsService } from 'app/view/departments/services/departments.service';
import { Employees } from 'app/view/employees/modal/employees';
import { EmployeesService } from 'app/view/employees/services/employees.service';
import { ToastrService } from 'ngx-toastr';
import { emit } from 'process';
import { EMPTY } from 'rxjs';

@Component({
  selector: 'app-client-form-shared',
  templateUrl: './client-form-shared.component.html',
  styleUrls: ['./client-form-shared.component.scss']
})

// -------------------------- Client Form Shared Component  ==>> all code is created by  Eng Ahmed Abdelhameed Ali --------------------------

export class ClientFormSharedComponent implements OnInit  {
  @Output() clientUpdated:EventEmitter<string>=new EventEmitter()
  url: string = environment.url;
  companyID: number = 0;
  clientsForm: FormGroup;
  @Input() clientID: number = 0;
  files: any[] = [];
  ListOfClientJobs: DataListOfClientJobs[];
  ListOfClientJobCategories: DataListOfClientJobs[];
  clientCommunicationWay_Id: number = 0;
  listOfClientCommunicationWays: DataListOfClientJobs[];
  listOfStates: any[] = [];
  ListOfId: any[] = [];
  listOfRegion: any[] = [];
  listOfClientTypes: any[] = [];
  listOfDepartment: any[] = [];
  listOfClientSources: any[] = [];
  listOfClientContactImportances: any[] = [];
  loadingShow: boolean = false;
  loadingclients: boolean = false;
  state_Id: any = null;
  clientDetails: any;
  listOfLotsOfClientStatus: any[] = [];
  listOfEmployees: any[] = [];
  stateClient: string = '';
  listOfIndustrySectors: any[] = [];
  listOfIndustrySectorFiled: any[] = [];
  ListOfCountries: any[] = [];

  constructor(
    private _formBuilder: FormBuilder,
    private _ActivatedRoute: ActivatedRoute,
    private _ClientsService: ClientService,
    private _DepartmentsService: DepartmentsService,
    private _EmployeesService: EmployeesService,
    private toastrService: ToastrService,
    private _Router: Router,
    private modalService : NgbModal,
    public activeModal : NgbActiveModal
) {
    // ---------------------------------- initiat clients Form --------------------------
    this.clientsForm = this._formBuilder.group({
      companyName: [null],
      mobile: [null],
      phoneNumber: [null, [Validators.required, Validators.pattern('[0-9]+')]],
      commercialActivity: [null],
      commercialName: [null],
      generalManagerName: [null],
      salesManagerName: [null],
      email: [null, [Validators.email]],
      // department_Id: [null, [Validators.required]],
      image: [null],
      clientType_Id: [null],
      Latitude: [null],
      Longitude: [null],
      IndustrySector_Id: [null],
      IndustrySectorFiled_Id: [null],
      ClientStatus_Id: [null],
      ClientSource_Id: [null],
      ClientContactImportance_Id: [null],
      EmployeeIds: [[]],
      ClientAddresses: this._formBuilder.array([]),
      ClientContactLists: this._formBuilder.array([]),
      Files: this._formBuilder.array([]),
    });

    this._ActivatedRoute.paramMap.subscribe((param: any) => {
      this.companyID = +param.params['companyID'];
      this.clientID = +param.params['id'];
      this.stateClient = param.params['stateClientId'];
      this.clientsForm.patchValue({ ClientStatus_Id: 3 })
    })
  }


  // ---------------------------------- get FormArrays  --------------------------
  get formFileClient() {
    return this.clientsForm.controls["Files"] as FormArray;
  }

  get ClientAddresses() {
    return this.clientsForm.controls["ClientAddresses"] as FormArray;
  }

  get ClientContactLists() {
    return this.clientsForm.controls["ClientContactLists"] as FormArray;
  }

  get form() {
    return this.clientsForm.controls;
  }
  // ------------------------------------------------------------------------------

  // initaite files array
  initFormFileClient(): FormGroup {
    return this._formBuilder.group({
      Description: [null],
      File: [null],
      path: [null],
      id: [null]
    })
  }

  // initaite Client Addresses
  initFormClientAddresses(item: any = null): FormGroup {
    return this._formBuilder.group({
      PostalCode: [item ? item.postalCode : null], // remove Validators.required ---- Eng Ahmed-Abdelhameed
      addressInDetails: [item ? item.addressInDetails : null],
      country_Id: [item ? item.country_Id : null, Validators.required],
      listOfCountry: [this.ListOfCountries],
      state_Id: [item ? item.state_Id : null, Validators.required],
      listOfStates: [[]],
      region_Id: [item ? item.region_Id : null, Validators.required],
      listOfRegion: [[]],
    })
  }

  // initaite Client Contact Lists
  initFormClientContactLists(): FormGroup {
    return this._formBuilder.group({
      FirstName: [null],
      LastName: [null],
      Telephone: [null, [Validators.pattern('[0-9]+')]],
      Mobile: [null],
      Email: [null, [Validators.email]],
    })
  }
  // ----------------------------------------------------------------------------------------------------

  // ----------------------------- append form groups in the form arrays --------------------------------
  addFormFileClient() {
    this.formFileClient.push(this.initFormFileClient());
  }

  addFormClientAddresses(item: any = null) {
    console.log(this.initFormClientAddresses(item).value);

    this.ClientAddresses.push(this.initFormClientAddresses(item));
  }

  addFormClientContactLists() {
    this.ClientContactLists.push(this.initFormClientContactLists());
  }

  deleteFormClientContactLists(index: number) {
    this.ClientContactLists.removeAt(index);
  }
  // ----------------------------------------------------------------------------------------------------

  // ----------------------------- delete form groups in the form arrays --------------------------------
  deleteFormFileClient(index: number) {
    this.formFileClient.removeAt(index);
    this.files.splice(index, 1);
  }

  deleteFormClientAddresses(index: number) {
    this.ClientAddresses.removeAt(index);
  }
  // ----------------------------------------------------------------------------------------------------

  ngOnInit(): void {
    this.ListOfClientSources();
    this.ListOfClientContactImportances();
    this.ListOfClientTypes();
    this.ListOfDepartment();
    this.ListOfLotsOfClientStatus();
    this.GetAllIndustrySectors();
    this.clientID ? this.showClients(this.clientID) : EMPTY;
    this.getListOfCountries();
  }

  ListOfClientTypes(): void {
    this._ClientsService.ListOfClientTypes().subscribe({
      next: (res: Employees) => {
        this.listOfClientTypes = res.data;
      }
    })
  }

  getListOfCountries(): void {
    this._EmployeesService.ListOfCountries().subscribe({
      next: (res: Employees) => {
        this.ListOfCountries = res.data;
      }
    })
  }

  getListOfStates(countryId: number, index: number): void {
    this.ClientAddresses.controls[index].get('state_Id').setValue(null)
    this.ClientAddresses.controls[index].get('region_Id').setValue(null)
    if (countryId) {
      this._EmployeesService.ListOfStates(countryId).subscribe({
        next: (res: Employees) => {
          this.listOfStates = res.data;
          this.ClientAddresses.controls[index].patchValue({
            listOfStates: this.listOfStates
          })
        }
      })
    } else this.ClientAddresses.controls[index].get('listOfStates').reset();
  }

  getListOfRegions(stateID: number, index: number): void {
    this.ClientAddresses.controls[index].get('region_Id').setValue(null)
    if (stateID) {
      this._EmployeesService.ListOfRegions(stateID).subscribe({
        next: (res: Employees) => {
          this.listOfRegion = res.data;
          this.ClientAddresses.controls[index].patchValue({
            listOfRegion: this.listOfRegion
          })
        }
      })
    } else this.ClientAddresses.controls[index].get('listOfRegion').reset();
  }

  uploadImg(event: any, index: number): void {
    if (event.target.files && event.target.files[0]) {
      let reader = new FileReader();
      this.formFileClient.controls[index].patchValue({
        File: event.target.files[0]
      })
      reader.onload = (event: any) => {
        this.formFileClient.controls[index].patchValue({
          path: event.target.result
        })
      };
      reader.readAsDataURL(event.target.files[0]);
    }
  }

  GetAllIndustrySectors(): void {
    this._ClientsService.GetAllIndustrySectors().subscribe({
      next: (res: Employees) => {
        this.listOfIndustrySectors = res.data;
      }
    });
  }

  GetAllIndustrySectorFields(IndustrySectorId: number): void {
    // ------------------------ Eng Ahmed Abdelhameed -------------------------
    this.clientsForm.patchValue({
      IndustrySectorFiled_Id: ""
    })
    if (IndustrySectorId) {
      this._ClientsService.GetAllIndustrySectorFields(IndustrySectorId).subscribe({
        next: (res: Employees) => {
          // this.clientsForm.get('IndustrySectorFiled_Id').patchValue(null);
          this.listOfIndustrySectorFiled = res.data ? res.data : [];
          console.log(this.listOfIndustrySectorFiled);

        },
        error: () => {
          this.listOfIndustrySectorFiled = []
          this.clientsForm.patchValue({
            IndustrySectorFiled_Id: ""
          })
        }
      })
    } else this.listOfIndustrySectorFiled = [];
    // ------------------------------------------------------------------------
  }

  ListOfDepartment(): void {
    this._DepartmentsService.ListOfDepartment().subscribe({
      next: (res: any) => {
        this.listOfDepartment = res.data;
      }
    })
  }

  ListOfClientCommunicationWays(): void {
    this._ClientsService.ListOfClientCommunicationWays().subscribe({
      next: (res: ListOfClientJobs) => {
        this.listOfClientCommunicationWays = res.data;
      }
    })
  }

  ListOfEmployees(department_Id: number): void {
    let query = {
      CompanyId: this.companyID,
      DepartmentId: department_Id,
    }
    this._EmployeesService.ListOfEmployees(query).subscribe({
      next: (res: ListOfClientJobs) => {
        this.listOfEmployees = res.data;
      }
    })
  }

  ListOfLotsOfClientStatus(): void {
    this._ClientsService.ListOfLotsOfClientStatus().subscribe({
      next: (res: ListOfClientJobs) => {
        if (this.stateClient == 'company') {
          this.listOfLotsOfClientStatus = res.data.filter((x: any) => x.id != 1);
        } else {
          this.listOfLotsOfClientStatus = res.data
        }
      }
    })
  }

  getListOfClientJobs(event): void {
    this._ClientsService.ListOfClientJobs(event).subscribe({
      next: (res: ListOfClientJobs) => {
        this.ListOfClientJobs = res.data
      }
    })
  }

  getListOfClientJobCategories(): void {
    this._ClientsService.ListOfClientJobCategories().subscribe({
      next: (res: ListOfClientJobs) => {
        this.ListOfClientJobCategories = res.data
      }
    })
  }

  ListOfClientSources(): void {
    this._ClientsService.ListOfClientSources().subscribe({
      next: (res: ListOfClientJobs) => {
        this.listOfClientSources = res.data
      }
    })
  }

  ListOfClientContactImportances(): void {
    this._ClientsService.ListOfClientContactImportances().subscribe({
      next: (res: ListOfClientJobs) => {
        this.listOfClientContactImportances = res.data
      }
    })
  }


  showClients(clientId: number) {
    this.loadingShow = true;
    this._ClientsService.getclientById(clientId).subscribe({
      next: (res: any) => {
        // this.state_Id = res.data.clientAddresses[0].state_Id != 0 ? res.data.clientAddresses[0].state_Id : null;
        this.loadingShow = false;
        this.clientDetails = res.data;
        res.data.clientJobCategory_Id ? this.getListOfClientJobs(res.data.clientJobCategory_Id) : null;
        res.data.industrySector_Id ? this.GetAllIndustrySectorFields(res.data.industrySector_Id) : null;
        this.clientsForm.patchValue({
          companyName: res.data.companyName,
          mobile: res.data.mobile,
          activity: res.data.activity,
          generalManagerName: res.data.generalManagerName,
          salesManagerName: res.data.salesManagerName,
          email: res.data.email,
          addressInDetail: res.data.addressInDetail,
          clientJobCategory_Id: res.data.clientJobCategory_Id ? res.data.clientJobCategory_Id : null,
          clientJob_Id: res.data.clientJob_Id ? res.data.clientJob_Id : null,
          region_Id: res.data.region_Id ? res.data.region_Id : null,
          department_Id: res.data.department_Id ? res.data.department_Id : null,
          IndustrySector_Id: res.data.industrySector_Id ? res.data.industrySector_Id : null,
          IndustrySectorFiled_Id: res.data.industrySectorFiled_Id ? res.data.industrySectorFiled_Id : null,
          phoneNumber: res.data.phoneNumber,
          commercialActivity: res.data.commercialActivity,
          commercialName: res.data.commercialName,
          ClientContactImportance_Id: res.data.clientContactImportance_Id ? res.data.clientContactImportance_Id : null,
          clientType_Id: res.data.clientType_Id ? res.data.clientType_Id : null,
          EmployeeIds: res.data.employeeIds ? res.data.employeeIds : null,
        })
        this.clientCommunicationWay_Id = res.data.clientCommunicationWay_Id;
        res.data.clientAddresses.forEach((ele: any, index: number) => {
          this.addFormClientAddresses(ele);
          this.getListOfStates(res.data.clientAddresses[index].country_Id, index);
          this.getListOfRegions(res.data.clientAddresses[index].state_Id, index);
          this.ClientAddresses.controls[index].patchValue({
            PostalCode: res.data.clientAddresses[index].postalCode,
            addressInDetails: res.data.clientAddresses[index].addressInDetails,
            country_Id: res.data.clientAddresses[index].country_Id,
            state_Id: res.data.clientAddresses[index].state_Id,
            region_Id: res.data.clientAddresses[index].region_Id,
          })
        })
        res.data.clientContactLists.forEach((ele: any, index: number) => {
          this.addFormClientContactLists();
          this.ClientContactLists.controls[index].patchValue({
            FirstName: res.data.clientContactLists[index].firstName,
            LastName: res.data.clientContactLists[index].lastName,
            Telephone: res.data.clientContactLists[index].telephone,
            Mobile: res.data.clientContactLists[index].mobile,
            Email: res.data.clientContactLists[index].email,
          })
        })

        res.data.atachments.forEach((ele: any, index: number) => {
          this.addFormFileClient();
          this.formFileClient.controls[index].patchValue({
            path: `${this.url + ele.file}`,
            Description: ele.description,
            id: ele.id,
          })
        })
      }, error: (err: Error) => {
        this.loadingShow = false;
      }
    })
  }

  RemoveImage(id: number) {
    this.ListOfId.push(id)
    this.DeleteFileOrMoreOfEmployee();
  }

  DeleteFileOrMoreOfEmployee() {
    this._ClientsService.DeleteFileOrMoreOfClient(this.ListOfId).subscribe({
      next: (res: Clients) => {
        this.ListOfId = [];
        this.toastrService.error(res.message);
      }, error: (err: Error) => {
        this.toastrService.error(err.message);
      }
    })
  }

  // -------------------------- Update Clients --------------------------
  updateClients(): void {
    let value = this.clientsForm.value;
    value['id'] = this.clientID
    this._ClientsService.updateClients(value, this.clientID).subscribe({
      next: (res: Clients) => {
        this.loadingclients = false;
        // this._Router.navigate(['/companies', this.companyID, 'clients'])
        // this._Router.navigate(['/companies', this.companyID, 'clients', this.stateClient])
        this.toastrService.success(res.message);
        this.activeModal.dismiss('Cross click');
        this.clientUpdated.emit("updated");
      }, error: (err: Error) => {
        this.loadingclients = false;
        this.toastrService.error(err.message);
      }
    })
  }
  //----------------------------------------------------------------------

  // -------------------------- Add Clients --------------------------
  getAddClients(): void {
    let value = this.clientsForm.value;
    this._ClientsService.addClient(value).subscribe({
      next: (res: Clients) => {
        this.loadingclients = false;
        // this._Router.navigate(['/companies', this.companyID, 'clients'])
        this.toastrService.success(res.message);
      }, error: (err: Error) => {
        this.loadingclients = false;
        this.toastrService.error(err.message);
      }
    })
  }
  //----------------------------------------------------------------------

  onSubmit() {
    this.loadingclients = true;
    !this.clientID ? this.getAddClients() : this.updateClients();
  }
}

